<template>
  <div>
    <div class="mt-4 mb-3 d-flex align-items-center justify-content-between">
      <div>
        <h1 class="page-title">{{ $t('dashboard.tasks.title') }} </h1>
      </div>
      <b-button variant="primary" v-on:click="clickOnCreateBtn()">
        {{ $t('Add') }}
      </b-button>
    </div>

    <b-card>
      <b122-table
        ref="B122TableDashboardTasks"
        :delete-item="allowDelete"
        :edit-item="allowEdit"
        :empty-button="$t('operationTask.emptyButton').toString()"
        :empty-text="$t('operationTask.emptyText').toString()"
        :empty-title="$t('operationTask.emptyTitle').toString()"
        :fields="tableFields"
        :get-b122-table-results-url="'/operationTask/getB122TableResults'"
        :use-filters="true"
        :use-pagination="true"
        identifier="B122TableDashboardTasks"
        init-b122-table-url="/operationTask/initB122Table"
        @add="clickOnCreateBtn"
        @clickOnDeleteBtn="clickOnDeleteBtn"
        @clickOnEditBtn="clickOnEditBtn"
        @clickOnShowBtn="clickOnShowBtn"
        @setTotalCount="setTotalCount">

        <template #cell(assignedTo)="data">
          <span v-if="data.item.assignedTo" class="assigned-to-name">
            {{ data.item.assignedTo.fullName }}
          </span>
          <span v-else class="text-muted">
            {{ $t('OperationTask.notAssigned') }}
          </span>
        </template>

        <template #cell(status)="data">
          <b-form-select
            id="statut-input"
            v-model="data.item.status.value"
            :style="{borderColor: getColor(data.item.status.mainColor), backgroundColor: getColor(data.item.status.secondaryColor) }"
            class="bold-text main-color-text"
            required
            size="sm"
            style="max-width: 15vw;"
            v-on:change="saveStatusTask(data.item.id, data.item.status.value)">
            <option v-for="status in statusTask" :value="status.value">
              {{ $t(status.text) }}
            </option>
          </b-form-select>
        </template>
      </b122-table>
    </b-card>

    <Item-delete-modal
      id="task-delete-modal"
      :beginsWithVoyel="false"
      :isFeminine="true"
      :selectedItem="selectedTask"
      controllerName="operationTask"
      itemSingularName="tâche"
      itemSingularNameUpp="Tâche"
      @didDeleteItem="didDeleteTask()">
    </Item-delete-modal>

    <b-modal
      id="no-operations-modal"
      :cancel-title-html="$t('Cancel')"
      :ok-title="$t('Add') + ' ' + $t('a.e') + ' ' + $t('operation')"
      :title="$t('operation.emptyTitle')"
      centered
      ok-variant="primary"
      @ok="addOperation">
      <p>
        {{ $t('dashboard.no.operations') }}
      </p>
    </b-modal>
  </div>
</template>

<script>

import B122Table from "../../../components/b122/B122Table";
import ItemDeleteModal from "../../../components/b122/ItemDeleteModal";
import api from "../../../services/api";

export default {
  name: "DashboardTasksComponent",

  components: {
    B122Table,
    ItemDeleteModal
  },

  props: {
    operationId: {
      default: null
    }
  },

  data() {
    return {
      totalCount: 0,

      statusTask: [],
      nbOperations: null,

      allowCreate: this.$store.getters.isEstateAgent || this.$store.getters.isCollaborator || this.$store.getters.isCollaboratorPlus,
      allowEdit: this.$store.getters.isEstateAgent || this.$store.getters.isCollaborator || this.$store.getters.isCollaboratorPlus,
      allowDelete: this.$store.getters.isEstateAgent || this.$store.getters.isCollaborator || this.$store.getters.isCollaboratorPlus,

      selectedTask: null
    }
  },

  computed: {
    tableFields() {
      let tableFields = [
        {
          label: this.$t('See'),
          key: 'show',
          sortable: false
        },
        {
          label: this.$t('OperationTask.name'),
          key: 'name',
          sortable: true
        },
        {
          label: this.$t("OperationTask.operation"),
          key: 'operation.name',
          sortable: true
        },
        {
          label: this.$t('OperationTask.deadlineDate'),
          key: 'deadlineDate',
          sortable: true,
          formatter: function (value) {
            return new Date(value).toLocaleDateString()
          }
        },
        {
          label: this.$t('OperationTask.assignedTo'),
          key: 'assignedTo',
          sortable: false
        },
        {
          label: this.$t('OperationTask.status'),
          key: 'status',
          sortable: true
        },
        {
          label: '',
          key: 'actions'
        }]
      return tableFields
    }
  },

  async mounted() {
    await this.getStatusTask()
    await this.fetchAllOperations()
  },

  methods: {
    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    async getStatusTask() {
      await api
        .get(`/operationTask/getStatusTask`)
        .then(response => {
          this.statusTask = response.data
        })
    },

    async fetchAllOperations() {
      api
        .get('/operation/getAllAuthorizedOperations')
        .then(response => {
          this.nboperations = response.data.length
        })
    },

    getColor(color) {
      return color.toString()
    },

    saveStatusTask(id, status) {
      let data = new FormData()
      data.append('status', status)
      let url = '/operationTask/updateStatus/' + id

      api({
        method: 'POST',
        url: url,
        data: data
      })
        .then(() => {
          this.$refs.B122TableDashboardTasks.refreshTable()
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },


    clickOnCreateBtn() {
      if (this.nboperations === 0) {
        this.$bvModal.show('no-operations-modal')
      } else {
        this.$router.push({
          name: 'OperationTaskCreateEditFromDashboard',
          params: {
            fromDashboard: true,
            operationTaskId: null,
            operationId: this.operationId
          }
        })
      }
    },

    addOperation() {
      this.$router.push({
        name: 'OperationCreate'
      })
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'OperationTaskShowFromDashboard',
        params: {
          fromDashboard: true,
          operationId: this.operationId,
          operationTaskId: row.item.id
        }
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'OperationTaskCreateEditFromDashboard',
        params: {
          fromDashboard: true,
          operationTaskId: row.item.id,
          operationId: this.operationId
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.selectedTask = row.item
      this.$bvModal.show('task-delete-modal')
    },

    didDeleteTask() {
      this.selectedTask = null
      this.$refs.B122TableDashboardTasks.refreshTable()
    },
  }
}
</script>

<style scoped>
.assigned-to-name {
  font-weight: 500;
  color: var(--main-color-text);
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/DashboardTasksComponent.vue